var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveBudget({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11134_1117",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11134_1117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.025 21V18.85C10.1416 18.65 9.37912 18.2667 8.73745 17.7C8.09578 17.1333 7.62495 16.3333 7.32495 15.3L9.17495 14.55C9.42495 15.35 9.79578 15.9583 10.2875 16.375C10.7791 16.7917 11.425 17 12.225 17C12.9083 17 13.4875 16.8458 13.9625 16.5375C14.4375 16.2292 14.675 15.75 14.675 15.1C14.675 14.5167 14.4916 14.0542 14.125 13.7125C13.7583 13.3708 12.9083 12.9833 11.575 12.55C10.1416 12.1 9.15828 11.5625 8.62495 10.9375C8.09162 10.3125 7.82495 9.55 7.82495 8.65C7.82495 7.56667 8.17495 6.725 8.87495 6.125C9.57495 5.525 10.2916 5.18333 11.025 5.1V3H13.025V5.1C13.8583 5.23333 14.5458 5.5375 15.0875 6.0125C15.6291 6.4875 16.025 7.06667 16.275 7.75L14.425 8.55C14.225 8.01667 13.9416 7.61667 13.575 7.35C13.2083 7.08333 12.7083 6.95 12.075 6.95C11.3416 6.95 10.7833 7.1125 10.4 7.4375C10.0166 7.7625 9.82495 8.16667 9.82495 8.65C9.82495 9.2 10.075 9.63333 10.575 9.95C11.075 10.2667 11.9416 10.6 13.175 10.95C14.325 11.2833 15.1958 11.8125 15.7875 12.5375C16.3791 13.2625 16.675 14.1 16.675 15.05C16.675 16.2333 16.325 17.1333 15.625 17.75C14.925 18.3667 14.0583 18.75 13.025 18.9V21H11.025Z",
    fill: "url(#paint0_linear_11134_1117)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11134_1117",
    x1: 12,
    y1: 3,
    x2: 12,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD7409"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBudget);
export default __webpack_public_path__ + "static/media/active_budget.60113c628a517ece0a7a0ca572892451.svg";
export { ForwardRef as ReactComponent };